export default "__VITE_ASSET__BEXxaPob__"